const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/portfolio/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
import { redirectToLoopItemsIfNewUi } from './-redirectToLoopItems';
export const Route = createFileRoute('/(app)/org/$org/portfolio')({
  beforeLoad: async ({
    params,
    context: {
      queryClient,
      flags,
      organizationId
    }
  }) => {
    await redirectToLoopItemsIfNewUi(queryClient, flags, params.org, organizationId ?? '');
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(itemPanelSearchSchema)
});